import { Reveal } from "./Reveal";
import { Linkedin } from "lucide-react";

const team = [
  { name: "Marcus Sagos", role: "Founder & Principal Advisor", initials: "MS", bio: "20+ years guiding families through complex financial decisions." },
  { name: "Priya Nair, CFP®", role: "Director of Wealth Planning", initials: "PN", bio: "Architect of holistic, tax-aware planning strategies." },
  { name: "David Coulter, CFA", role: "Head of Investments", initials: "DC", bio: "Leads portfolio construction and risk management." },
  { name: "Jamal Sage", role: "Head Financial Planner", initials: "JS", bio: "Leads holistic financial planning and white-glove client care." },
];

export const Team = () => (
  <section id="team" className="py-24 md:py-32 bg-[#f4f7fd]" data-testid="team-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="overline text-primary mb-4">The People</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 leading-tight">
          Advisors you will actually know by name.
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {team.map((m, i) => (
          <Reveal key={m.name} delay={i * 0.08}>
            <div className="group bg-white rounded-2xl border border-border p-7 h-full hover:shadow-[0_24px_60px_-40px_rgba(11,42,91,0.5)] transition-shadow duration-300">
              <div className="h-16 w-16 rounded-full bg-[#0b2a5b] text-white flex items-center justify-center font-serif text-2xl">
                {m.initials}
              </div>
              <h3 className="mt-5 font-serif text-2xl text-slate-900">{m.name}</h3>
              <p className="text-sm font-medium text-primary mt-1">{m.role}</p>
              <p className="mt-3 text-slate-600 text-[0.9rem] leading-relaxed">{m.bio}</p>
              <div className="mt-5 inline-flex h-9 w-9 items-center justify-center rounded-full border border-border text-slate-400 group-hover:text-primary group-hover:border-primary transition-colors duration-300">
                <Linkedin size={16} />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
